import script from "./NewsCardTile.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsCardTile.vue?vue&type=script&setup=true&lang=js"

import "./NewsCardTile.vue?vue&type=style&index=0&id=0f0c7148&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f0c7148"]])

export default __exports__